  /*============Vehicle Controller
      ================================*/
  angular
    .module('vppApp')
    .controller('EligibleVehicleController', EligibleVehicleController);

  EligibleVehicleController.$inject = ['$scope', '$location', 'vppConfig', 'apiFactory', '$window', '$rootScope', '$http', 'EligibleVehiclesFactory', '$timeout', '$log', 'CGIFactory'];

  function EligibleVehicleController($scope, $location, vppConfig, apiFactory, $window, $rootScope, $http, EligibleVehiclesFactory, $timeout, $log, CGIFactory) {

    var modelPriceInfo = {};
    var modelInfo = {};
    var priceInfo = {};
    var brandId;
    var currentYear = year;
    var nextYear = year + 1;

    $scope.styleOptions = [{ name: "All", id: 1, value: "all" },
      { name: "Car", id: 2, value: "car" },
      { name: "SUV/Crossover", id: 3, value: "suv" },
      { name: "Truck", id: 4, value: "truck" }
    ];
    $rootScope.selectedStyleOption = $scope.styleOptions[0];

    apiFactory.vehiclesModel().then(function sucessVehiclesModel(response) {
      $scope.data = response.data;
      $scope.thisYearVehicle = $scope.data[currentYear];
      $scope.nextYearVehicle = $scope.data[nextYear];
      var arr = [];
      $scope.thisYearCombined = angular.extend({}, $scope.thisYearVehicle[6], $scope.thisYearVehicle[7], $scope.thisYearVehicle[8], $scope.thisYearVehicle[15]);
      $scope.maxThis = SortData($scope.thisYearCombined);
      $scope.yearLength = angular.extend({}, $scope.thisYearVehicle, $scope.nextYearVehicle);
      $scope.modelSummaryChevrolet = angular.extend({}, $scope.thisYearVehicle[8], $scope.nextYearVehicle[8]);
      $scope.modelSummaryCadillac = angular.extend({}, $scope.thisYearVehicle[7], $scope.nextYearVehicle[7]);
      $scope.modelSummaryBuick = angular.extend({}, $scope.thisYearVehicle[6], $scope.nextYearVehicle[6]);
      $scope.modelSummaryGmc = angular.extend({}, $scope.thisYearVehicle[15], $scope.nextYearVehicle[15]);

      modelInfo = response.data;

      EligibleVehiclesFactory.getVehicleLinks().then(function(response) {
        $scope.vehicleLinks = response.data;
      });

      // this callback will be called asynchronously
      // when the response is available
    }, function errorCallback(response) {
      console.log(response.data.errors);
      $scope.serverError = response.data.errors;
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });

      apiFactory.vehiclesPricing().then(function sucessVehiclesPricing(response) {
          priceInfo = response.data;
          $scope.modelNamePriceChevy = Summary2015($scope.modelSummaryChevrolet, "Chevrolet");
          $scope.modelNamePriceCadillac = Summary2015($scope.modelSummaryCadillac, "Cadillac");
          $scope.modelNamePriceBuick = Summary2015($scope.modelSummaryBuick, "Buick");
          $scope.modelNamePriceGmc = Summary2015($scope.modelSummaryGmc, "GMC");
        }, function errorCallback(response) {
          console.log(response.data.errors);
          $scope.serverError = response.data.errors;
          // called asynchronously if an error occurs
          // or server returns response with an error status.
        });
    


    function SortData(o) {
      var sorted = {},
        key, a = [];

      for (key in o) {
        if (o.hasOwnProperty(key)) {
          a.push(key);
        }
      }

      a.sort();

      for (key = 0; key < a.length; key++) {
        sorted[a[key]] = o[a[key]];
      }
      return sorted;
    }

    function ObjectLength(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    };

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function getPrice(key) {
      var highValueId = priceInfo[key].highStyle.styleId;
      var lowValueId = priceInfo[key].lowStyle.styleId;
      var highPrice = "$" + numberWithCommas(priceInfo[key][highValueId].baseMsrp.price);
      var lowPrice = "$" + numberWithCommas(priceInfo[key][lowValueId].baseMsrp.price);
      return lowPrice.toString() + " - " + highPrice.toString();
    }

    function getVehicleLink(model, brand) {
      var data;
      if ($scope.vehicleLinks != null) {
        for (var i = 0; i < $scope.vehicleLinks.brand[brand].vehicles.length; i++) {
          if ($scope.vehicleLinks.brand[brand].vehicles[i].name === model.modelName) {
            data = $scope.vehicleLinks.brand[brand].vehicles[i].link;
            return data;
          }
          //if don't have link here will be needed a default link
        }
      }
      return data;
    }

    function getName(name) {
      var data = name;
      if (name.indexOf('Built After') != -1) {
        data = name.substr(0, name.indexOf('Built After') - 1);
      }
      return data;
    }

    function getImagePopup(image) {
      var newImage = image.replace("deg01", "deg03");
      return newImage;
    }

    //info for each brand or accordion
    //TO DO : Refactor this function
    function Summary2015(model, brand) {
      var year;
      var modelNamePrice = [];
      // var year = $scope.year;
      var key = [];

      for (key in model) {
        var objKeys = Object.keys($scope.maxThis);
        var last = objKeys[objKeys.length - 1];
        if ($scope.thisYearCombined.hasOwnProperty(key)) {
          year = currentYear;
        } else {
          year = nextYear;
        }
        var item = {};
        if (priceInfo[key] !== undefined) {
          item["brand"] = brand;
          item["year"] = year;
          item["name"] = getName(model[key].modelName);
          item["prices"] = getPrice(key);
          item["msrp"] = numberWithCommas(priceInfo[key][priceInfo[key].lowStyle.styleId].baseMsrp.price);
          item["image"] = CGIFactory.getCGI(priceInfo, key, year, brand);
          item["imagePopup"] = getImagePopup(item["image"]);
          item["style"] = model[key].modelCategory;
          item["link"] = getVehicleLink(model[key], brand);
          modelNamePrice.push(item);
        }
      }
      return modelNamePrice;
    }
    //set status variable for SEO
    $scope.status = 'ready';

  };
